import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play_circle",
  "use": "icon-play_circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-play_circle\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M19,12a7,7,0,1,1-7-7A7,7,0,0,1,19,12Zm-4.9-.35-2.8-2a.49.49,0,0,0-.78.4V14a.49.49,0,0,0,.78.41l2.8-2A.49.49,0,0,0,14.1,11.65Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol